var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUsersAlt = function SvgIconUsersAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.992,
    height: 16.095,
    viewBox: "0 0 22.992 16.095",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.449,9.148a2.3,2.3,0,1,0-2.3-2.3A2.3,2.3,0,0,0,3.449,9.148Zm16.095,0a2.3,2.3,0,1,0-2.3-2.3A2.3,2.3,0,0,0,19.543,9.148Zm1.15,1.15h-2.3a2.292,2.292,0,0,0-1.62.668,5.255,5.255,0,0,1,2.7,3.93h2.371a1.148,1.148,0,0,0,1.15-1.15V12.6A2.3,2.3,0,0,0,20.693,10.3Zm-9.2,0A4.024,4.024,0,1,0,7.472,6.274,4.022,4.022,0,0,0,11.5,10.3Zm2.759,1.15h-.3a5.555,5.555,0,0,1-4.922,0h-.3A4.14,4.14,0,0,0,4.6,15.585V16.62a1.725,1.725,0,0,0,1.724,1.724H16.669a1.725,1.725,0,0,0,1.724-1.724V15.585A4.14,4.14,0,0,0,14.255,11.447Zm-8.036-.481A2.292,2.292,0,0,0,4.6,10.3H2.3A2.3,2.3,0,0,0,0,12.6v1.15A1.148,1.148,0,0,0,1.15,14.9H3.517A5.268,5.268,0,0,1,6.219,10.965Z",
    transform: "translate(0 -2.25)",
    fill: "#f6c866"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUsersAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-users-alt.b2980e99.svg";
export { ForwardRef as ReactComponent };